
// FancyDressActivity
import React from 'react';
import { FieldTrip22025 } from '../views';


const FancyDressActivityPage = () => {
  return <FieldTrip22025/>;
};

export default FancyDressActivityPage;